import React from 'react';

const DefaultPortlet = (portlet, props) => {
  //console.debug('volto-addons: No renderer found for portlet', portlet);
  return <div className="default-renderer-portlet" />;
};

export default DefaultPortlet;
